import { PaginationPayload } from "../../models/search";

export const parse = (params: URLSearchParams): PaginationPayload => {
  const dir = params.get("p_dir");
  return {
    direction: dir === "before" ? "before" : "after",
    ...(params.has("p_cur") && { cursor: params.get("p_cur")! })
  };
}

export const rebuild = (value: PaginationPayload, params: URLSearchParams = new URLSearchParams()): URLSearchParams => {
  params.has("p_dir") && params.delete("p_dir");
  (params.has("p_cur") && !value.cursor) && params.delete("p_cur");
  (value.direction !== "after" || !!value.cursor) && params.set("p_dir", value.direction);
  !!value.cursor && params.set("p_cur", value.cursor);
  return params;
}
